import { FaBarcode, FaCreditCard } from "react-icons/fa";
import { FaMoneyCheckDollar, FaPix } from "react-icons/fa6";

export const getMethodIcon = (tipoMetodo: string) => {
    const iconClass = 'w-6 h-6';
    switch (tipoMetodo) {
        case 'pix':
            return <FaPix className={`${iconClass} text-emerald-500`} />;
        case 'boleto':
            return <FaBarcode className={`${iconClass} text-gray-600`} />;
        case 'cartao_credito':
        case 'credit_card':
            return <FaCreditCard className={`${iconClass} text-blue-500`} />;
        case 'agConta':
            return <FaMoneyCheckDollar className={`${iconClass} text-yellow-600`} />;
        default:
            return <FaMoneyCheckDollar className={iconClass} />;
    }
};

export const getMethodName = (tipoMetodo: string) => {
    switch (tipoMetodo) {
        case 'cartao_credito':
        case 'credit_card':
            return 'Cartão de Crédito';
        case 'pix': return 'PIX';
        case 'boleto': return 'Boleto Bancário';
        case 'agConta': return 'AG Conta';
        default: return 'Método de Pagamento';
    }
};

export const formatCurrency = (value: number): string => {
    return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
    }).format(value);
};